import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import thunk from "redux-thunk";
import rootReducer from "../reducers";

//TODO : MAKE SURE THIS REDUX IS NOT AVAILABLE ON PRODUCTION, SO THAT NO ONE CAN ACCESS THE DATA DIRECTLY FROM REDUX
const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk))
);

export default store;
